import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Button, Icon, Table } from "semantic-ui-react";
import { useMediaQuery } from "react-responsive";
import { addHistoryToDb } from "../../../app/firestore/firestoreService";
import { setOriginalPartyId } from "../partySlice";

export default function PartyDocSignListItem({ doc, signingAsParty }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { party } = useSelector((state) => state.party);
  const isMobile = useMediaQuery({ query: "(max-width:768px)" });

  function handleSignClick() {
    // Use signingAsParty if provided (for shared email clients), otherwise use the logged-in party
    const partyToSignAs = signingAsParty || party;

    // console.log("Signing document:", doc.name);
    // console.log("Logged-in party:", party.role, party.id);
    // console.log("Signing as party:", partyToSignAs.role, partyToSignAs.id);

    // If signing as a different party (shared client), store the original party ID
    if (signingAsParty && signingAsParty.id !== party.id) {
      console.log("Storing original party ID:", party.id);
      dispatch(setOriginalPartyId(party.id));
    }

    addHistoryToDb(
      doc.transactionId,
      partyToSignAs,
      "opened for signing",
      doc.name
    );
    navigate(`/party/${partyToSignAs.id}/documents/${doc.id}/sign`);
  }

  return (
    <Table.Row
      key={doc.id}
      onClick={() => handleSignClick()}
      className="cursor-pointer"
    >
      <Table.Cell style={{ minWidth: "300px" }}>
        <Icon name="file pdf outline" size="large" />
        &nbsp;
        {doc.name}
      </Table.Cell>
      <Table.Cell>
        {doc.note ? doc.note : "Please sign this document."}
      </Table.Cell>
      <Table.Cell>
        <Button
          inverted
          floated={isMobile ? null : "right"}
          className={isMobile ? "fluid medium bottom margin" : null}
        >
          Sign
        </Button>
      </Table.Cell>
    </Table.Row>
  );
}
